/**
 * Application-level configuration
 * Centralized feature flags and app settings
 */

export const AppConfig = {
  /**
   * Controls whether to show exams from the 2024-2025 academic year
   * Academic year: Sept 1, 2024 (2024/09/01) - Aug 31, 2025 (2025/08/31)
   * Set to false to hide these exams from the exam list
   */
  SHOW_2425_EXAMS: true,

  /**
   * Cutoff date for filtering out old exams.
   * Exams with dates before this cutoff will be excluded from the exam list.
   */
  EXAM_CUTOFF_DATE: "2025-12-22T00:00:00",
} as const;
